import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useReviews } from '../../hooks/useReviews';
import { scrollToSection } from '../../utils/scroll';
import { REVIEWS_SECTION_ID } from './ReviewSummaryBar';
type ProductRatingProps = {
  size?: 'sm' | 'md';
  className?: string;
};

/** Gold-star rating line shown at the top of every product: "★★★★★ 4.9 · 2,300+ reviews". */
export function ProductRating({
  size = 'sm',
  className = ''
}: ProductRatingProps) {
  const {
    lang
  } = useLanguage();
  const es = lang === 'es';
  const {
    summary
  } = useReviews();
  const {
    pathname
  } = useLocation();
  const navigate = useNavigate();
  if (!summary.count) return null;
  const count = `${summary.count.toLocaleString(es ? 'es-US' : 'en-US')}${summary.isAggregate ? '+' : ''}`;
  const star = size === 'md' ? 'h-5 w-5' : 'h-4 w-4';
  const go = () => {
    if (pathname === '/') scrollToSection(REVIEWS_SECTION_ID);else navigate(`/#${REVIEWS_SECTION_ID}`);
  };
  return <button type="button" onClick={go} aria-label={`${summary.average.toFixed(1)} ${es ? 'de 5 estrellas' : 'out of 5 stars'}, ${count} ${es ? 'reseñas' : 'reviews'}`} className={`group inline-flex items-center gap-2 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice ${className}`} data-id="element-654" data-mp="4znh404ev3hl">
      <span className="inline-flex gap-0.5" aria-hidden data-id="element-655" data-mp="3ie0nurkdccwt">
        {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className={`${star} fill-[#FFC94D] text-[#FFC94D]`} strokeWidth={1.5} data-id="element-656" data-mp="33grg4narcwix" />)}
      </span>
      <span className={`font-semibold text-white ${size === 'md' ? 'text-base' : 'text-sm'}`} data-id="element-657" data-mp="38fb38r138ecv">{summary.average.toFixed(1)}</span>
      <span className={`text-titanium underline-offset-4 group-hover:text-white group-hover:underline ${size === 'md' ? 'text-base' : 'text-sm'}`} data-id="element-658" data-mp="11qocsxeuqey9">
        ({count} {es ? 'reseñas' : 'reviews'})
      </span>
    </button>;
}